<template>
  <div>
    <div class="main-content">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-header">
              <div class="card-title">{{ fluxo.id ? 'Editar' : 'Adicionar' }} Fluxo</div>
            </div>
            <div class="card-body">
              <hr />
              <small class="text-muted d-block mb-1" v-if="fluxo.id">
                O desenho do fluxo (nós/conexões) é editado no
                <router-link :to="'/fluxos/editor/' + fluxo.id">editor visual</router-link>, não aqui.
              </small>
              <div class="row">
                <div class="col-md-12">
                  <form action />
                  <div class="form-row">
                    <div class="col-md-6">
                      <label for="nome">
                        <span class="required">*</span> Nome:
                      </label>
                      <input autocomplete="new-password" type="text" id="nome" class="form-control" v-model="fluxo.nome" />
                    </div>
                    <div class="col-md-3">
                      <label for="padrao">Fluxo padrão:</label>
                      <select v-model="fluxo.padrao" class="form-control">
                        <option :value="false">Não</option>
                        <option :value="true">Sim - novas conversas começam aqui</option>
                      </select>
                    </div>
                    <div class="col-md-3">
                      <label for="status">Status:</label>
                      <select v-model="fluxo.status" class="form-control">
                        <option value="1">Ativo</option>
                        <option value="0">Inativo</option>
                      </select>
                    </div>
                  </div>
                  <div class="form-row mt-1">
                    <div class="col-md-12">
                      <label for="descricao">Descrição:</label>
                      <textarea id="descricao" class="form-control" rows="2" v-model="fluxo.descricao"></textarea>
                    </div>
                  </div>
                  <hr>
                  <span class="required_fields">
                    <span class="required">*</span>
                    <strong> Campos obrigatórios</strong>
                  </span>
                  <div class="form-group mt-1">
                    <div class="block text-right">
                      <router-link to="/fluxos" class="btn btn-back">
                        <i class="fa fa-arrow-left"></i> Voltar
                      </router-link>
                      <a class="btn btn-add ml-1" @click="save">
                        Salvar
                        <i class="fa fa-save"></i>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "fluxoAdd",
  data() {
    return {
      fluxo: {
        status: '1',
        padrao: false,
      },
      errors: undefined,
    };
  },
  methods: {
    save: function () {
      const self = this;
      let api = self.$store.state.api + "fluxos";

      if (self.fluxo.id) {
        self.fluxo._method = "PUT"
        api += "/" + self.fluxo.id;
      } else {
        // Esqueleto minimo valido - o editor visual completa o resto.
        self.fluxo.definicao = {
          versao_schema: 1,
          no_inicial: null,
          timeout_segundos: 900,
          mensagem_fallback: 'Não entendi. Vamos tentar de novo.',
          nos: [],
        };
      }

      axios
        .post(api, self.fluxo)
        .then((response) => {
          self.$message(
            "Sucesso",
            `Informações guardadas com sucesso`,
            "success"
          );
          this.$router.push("/fluxos");
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getFluxo: function (id) {
      const self = this;
      const api = self.$store.state.api + "fluxos/" + id;

      axios
        .get(api)
        .then((response) => {
          self.fluxo = response.data.data[0];
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
  },
  mounted: function () {
    const self = this;
    let id = self.$route.params.id;
    if (id) {
      self.getFluxo(id);
    }
  },
};
</script>
